var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Resource, { CharacteristicType } from "./Resource";
import Credential from "./Credential";
var Company = /** @class */ (function (_super) {
    __extends(Company, _super);
    function Company(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this, obj) || this;
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Company.buildFromJson(_this, obj);
        return _this;
    }
    Company.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'credentials') {
                        instance[prop] = new Credential(json[prop]);
                    }
                }
            }
        }
    };
    Company.prototype.exportToJson = function () {
        var JSONCharacteristic = _super.prototype.exportToJson.call(this);
        JSONCharacteristic["uid"] = this.uid;
        if (this.characteristics.length > 0) {
            JSONCharacteristic["characteristics"] = [];
            for (var _i = 0, _a = this.characteristics; _i < _a.length; _i++) {
                var characteristic = _a[_i];
                JSONCharacteristic["characteristics"].push(characteristic.exportToJson());
            }
        }
        if (this.credentials) {
            JSONCharacteristic["credentials"] = this.credentials.exportToJson();
        }
        return JSONCharacteristic;
    };
    Object.defineProperty(Company.prototype, "legal_form", {
        /** Setter & Getter of Characteristics**/
        get: function () {
            return this.get(CharacteristicType.LEGAL_FORM);
        },
        set: function (value) {
            this.set(CharacteristicType.LEGAL_FORM, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "legal_identifier", {
        get: function () {
            return this.get(CharacteristicType.LEGAL_IDENTIFIER);
        },
        set: function (value) {
            this.set(CharacteristicType.LEGAL_IDENTIFIER, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "name", {
        get: function () {
            return this.get(CharacteristicType.BUSINESS_NAME);
        },
        set: function (value) {
            this.set(CharacteristicType.BUSINESS_NAME, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "legal_representative", {
        get: function () {
            return this.get(CharacteristicType.LEGAL_REPRESENTATIVE);
        },
        set: function (value) {
            this.set(CharacteristicType.LEGAL_REPRESENTATIVE, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "address", {
        get: function () {
            return this.get(CharacteristicType.ADDRESS);
        },
        set: function (value) {
            this.set(CharacteristicType.ADDRESS, value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "password", {
        /** Setter & Getter of Password **/
        get: function () {
            if (this.credentials && this.credentials.password) {
                return this.credentials.password;
            }
            else {
                return '';
            }
        },
        set: function (value) {
            if (this.credentials === undefined) {
                this.credentials = new Credential();
            }
            this.credentials.password = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "intraVat", {
        get: function () {
            return this.get('INTRA_VAT');
        },
        set: function (value) {
            this.set(CharacteristicType.UNDEFINED, {
                key: 'INTRA_VAT',
                value: value
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Company.prototype, "fullname", {
        get: function () {
            var _a;
            if (this.name !== null) {
                (_a = this.name) !== null && _a !== void 0 ? _a : '';
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    return Company;
}(Resource));
export { Company };
//# sourceMappingURL=Company.js.map